export default function useLocalization() {
  const formatCurrency = (amount: number,  zeroIsFree: boolean = true, currency: string = 'USD'): string => {
    if (amount === 0 && zeroIsFree) return 'Free';
    
    return amount.toLocaleString('en-US', {
      style: 'currency',
      currency: currency
    });
  };

  return {
    formatCurrency
  };
}